import {css} from "@panda/css";

import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IVendorDetailApplication} from "../../vendor/types/IVendorDetailApplication";

interface IProps {
    vendor: IVendorDetailApplication;
    buttonText: string;
    offerPersonalDataProcessorName?: string;
    offerPrivacyPolicyUrl?: string | null;
    offerPersonalDataProcessorUrl?: string | null;
}

export function LeadVendorRodoTerms(props: IProps) {
    const {vendor, buttonText, offerPersonalDataProcessorName, offerPrivacyPolicyUrl, offerPersonalDataProcessorUrl} = props;

    const rodoTermsUrl = rpAppLink.rodoTerms.base();
    const vendorRodoTermsUrl =
        vendor.configuration.privacy_policy_file ||
        offerPersonalDataProcessorUrl ||
        offerPrivacyPolicyUrl ||
        vendor.configuration.privacy_policy_url ||
        rodoTermsUrl;
    const showOfferPersonalDataProcessor = !!offerPersonalDataProcessorName && !!offerPersonalDataProcessorUrl;

    const name = offerPersonalDataProcessorName ? offerPersonalDataProcessorName : vendor.name;
    const rodoUrl = showOfferPersonalDataProcessor ? offerPersonalDataProcessorUrl : vendorRodoTermsUrl;

    return (
        <Text variant="info_txt_3" color="var(--colors-gray-800)">
            Kliknięcie „{buttonText}” oznacza przekazanie danych kontaktowych do {name} –{" "}
            <Link href={rodoUrl} target="_blank" textClassName={rodoLink}>
                dowiedz się więcej o przetwarzaniu Twoich danych.
            </Link>
        </Text>
    );
}

const rodoLink = css({
    fontSize: "inherit",
    lineHeight: "inherit",
    textDecoration: "underline"
});
import {css} from "@panda/css";

import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IVendorDetailApplication} from "../../vendor/types/IVendorDetailApplication";

interface IProps {
    vendor: IVendorDetailApplication;
    buttonText: string;
    offerPersonalDataProcessorName?: string;
    offerPrivacyPolicyUrl?: string | null;
    offerPersonalDataProcessorUrl?: string | null;
}

export function LeadVendorRodoTerms(props: IProps) {
    const {vendor, buttonText, offerPersonalDataProcessorName, offerPrivacyPolicyUrl, offerPersonalDataProcessorUrl} = props;

    const rodoTermsUrl = rpAppLink.rodoTerms.base();
    const vendorRodoTermsUrl =
        vendor.configuration.privacy_policy_file ||
        offerPersonalDataProcessorUrl ||
        offerPrivacyPolicyUrl ||
        vendor.configuration.privacy_policy_url ||
        rodoTermsUrl;
    const showOfferPersonalDataProcessor = !!offerPersonalDataProcessorName && !!offerPersonalDataProcessorUrl;

    const name = offerPersonalDataProcessorName ? offerPersonalDataProcessorName : vendor.name;
    const rodoUrl = showOfferPersonalDataProcessor ? offerPersonalDataProcessorUrl : vendorRodoTermsUrl;

    return (
        <Text variant="info_txt_3" color="var(--colors-gray-800)">
            Kliknięcie „{buttonText}” oznacza przekazanie danych kontaktowych do {name} –{" "}
            <Link href={rodoUrl} target="_blank" textClassName={rodoLink}>
                dowiedz się więcej o przetwarzaniu Twoich danych.
            </Link>
        </Text>
    );
}

const rodoLink = css({
    fontSize: "inherit",
    lineHeight: "inherit",
    textDecoration: "underline"
});
